import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'toast-usage',
  templateUrl: './toast-usage.component.html',
  styleUrls: ['./toast-usage.component.sass']
})
export class ToastUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
